import { useTranslation } from 'react-i18next';

const MAIN_SITE_URL = 'https://kaspreadsheet.com';

export default function CTA() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20flatlay%20of%20premium%20streetwear%20products%20sneakers%20hoodies%20caps%20and%20accessories%20spread%20across%20a%20warm%20neutral%20surface%20soft%20natural%20light%20editorial%20product%20photography%20clean%20minimal%20aesthetic&width=1920&height=600&seq=cta-bg-product&orientation=landscape"
          alt="CSSBuy product collection"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-900/80 to-accent-900/60" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-6">
          {t('cta_title')}
        </h2>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-4 bg-white text-primary-600 rounded-full font-semibold text-base hover:bg-background-50 transition-all shadow-lg whitespace-nowrap"
          >
            {t('cta_button_1')}
          </a>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-4 bg-white/10 text-white border border-white/30 rounded-full font-semibold text-base hover:bg-white/20 backdrop-blur-sm transition-all whitespace-nowrap"
          >
            {t('cta_button_2')}
          </a>
        </div>
      </div>
    </section>
  );
}